import { TruckIcon } from '@heroicons/react/24/outline';

import { Badge } from '@/components/ui/catalyst/badge';
import { cn } from '@/lib/utils';

import { formatMailingClass } from './enumFormatters';

interface MailingClassBadgeProps {
  mailingClass: string | undefined;
  className?: string;
  size?: 'small' | 'medium';
}

const MailingClassBadge = ({
  mailingClass,
  className,
  size = 'medium',
}: MailingClassBadgeProps) => {
  if (!mailingClass) {
    return null;
  }

  const getVariant = (classType: string) => {
    if (classType.includes('express') || classType.includes('overnight')) {
      return 'red'; // Express/urgent
    }
    if (classType.includes('priority')) {
      return 'amber'; // Priority
    }
    if (classType.includes('first_class')) {
      return 'blue'; // First class
    }
    return 'zinc'; // Standard/ground
  };

  const sizeClasses = {
    small: 'text-xs px-1.5 py-0.5',
    medium: 'text-sm px-2 py-1',
  };

  return (
    <Badge
      color={getVariant(mailingClass)}
      className={cn(
        'inline-flex items-center gap-1 font-medium',
        sizeClasses[size],
        className,
      )}
    >
      <TruckIcon className="h-3 w-3" />
      {formatMailingClass(mailingClass)}
    </Badge>
  );
};

export { MailingClassBadge };
